import React, { useState, useEffect } from 'react';
import Header from '../Header/Header'
import ServiciosData from '../../Components/Admin/ServiciosData/ServiciosData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import { useLocation } from 'react-router-dom';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';
import { puedeVerMenu } from '../../Helpers/rolesPermisos';

export default function Servicios() {
    const usuarioLegued = getUsuario();
    const [loading, setLoading] = useState(!usuarioLegued?.idUsuario);

    useEffect(() => {
        if (usuarioLegued?.idUsuario) return;
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };
        fetchData();
    }, []);
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>

                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {puedeVerMenu(usuarioLegued.rol, 'servicios') ? (
                                <ServiciosData />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <ServiciosData />
                    )}

                </div>
            </section>
        </div>
    )
}

